angular.module 'zc.projects'

.directive 'zcCampaignStatus', ($q, $translate, campaignStatuses, UniqueCouponCode) ->
  restrict: 'E'
  scope:
    campaign: '='
    showIcon: '=?'
    suppressErrorMessage: '<'
  templateUrl: '/templates/projects.campaigns/views/directives/label_campaign_status.html'

  link: (scope, element, attrs) ->
    $(element).addClass('campaign-status')
    hasIncentives = (campaign) ->
      _.get(campaign, 'incentives', []).length > 0
    hasActiveIncentives = (campaign) ->
      return false unless hasIncentives(campaign)
      return typeof _.find(campaign.incentives, { current_status: 'active' }) != 'undefined'

    selectStatusText = (campaign) ->
      if campaign.iw_current_status is 'preview'
        "#{campaignStatuses['preview'].text} #{$translate.instant('projectsCampaigns.directives.labelCampaignStatus.wholeDelivery')}"
      else if campaign.iw_current_status is 'enable'
        "#{campaignStatuses['active'].text} #{$translate.instant('projectsCampaigns.directives.labelCampaignStatus.wholeDelivery')}"
      else if campaign.iw_current_status is 'disable'
        "#{campaignStatuses['terminated'].text} #{$translate.instant('projectsCampaigns.directives.labelCampaignStatus.wholeDelivery')}"
      else if campaign.iw_current_status is 'incomplete_setting'
        "#{campaignStatuses['incomplete'].text} #{$translate.instant('projectsCampaigns.directives.labelCampaignStatus.generalDelivery')}"
      else
        campaignStatuses[campaign.current_status].text

    selectStatusClass = (campaign) ->
      if campaign.iw_current_status is 'preview'
        campaignStatuses['preview'].statusClass
      else if campaign.iw_current_status is 'enable'
        campaignStatuses['active'].statusClass
      else if campaign.iw_current_status is 'disable'
        campaignStatuses['terminated'].statusClass
      else
        campaignStatuses[campaign.current_status].statusClass

    if scope.campaign.current_status is 'active' and
       scope.campaign.current_incentive?.incentive_type is 'unique_coupon_code'
      query =
        projectId: scope.campaign.project_id
        incentiveId: scope.campaign.current_incentive.id
      $q.all [
        UniqueCouponCode.count(query)
        UniqueCouponCode.count(_.assignIn({assigned: 1}, query))
      ]
      .then ([totalCount, assignedCount]) ->
        unassignedCount = totalCount - assignedCount

        scope.text = selectStatusText scope.campaign
        scope.statusClass = selectStatusClass scope.campaign
        unless hasActiveIncentives(scope.campaign)
          scope.errorMessage = $translate.instant('projectsCampaigns.directives.labelCampaignStatus.codeExpired')
        else if unassignedCount is 0
          scope.errorMessage = $translate.instant('projectsCampaigns.directives.labelCampaignStatus.codeSnip')
    else
      scope.text = selectStatusText scope.campaign
      scope.statusClass = selectStatusClass scope.campaign
      if not scope.suppressErrorMessage
        if scope.campaign.current_status is 'blocked' and scope.campaign.auto_restart
          scope.errorMessage = $translate.instant('projectsCampaigns.directives.labelCampaignStatus.budgetLimitStop')



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.campaigns/directives/label_campaign_status.js.coffee